import { Component, Input, OnChanges, ViewEncapsulation } from '@angular/core';

import { WebApiModel } from '../../../models/web-api.model';
import { RouterHelperService } from '../../../services/router-helper.service';
import { SettingsService } from '../../../services/settings.service';

@Component({
  selector: 'hcf-person-detail',
  templateUrl: './person-detail.component.html',
  styleUrls: ['./person-detail.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class PersonDetailComponent implements OnChanges {
  @Input() person: WebApiModel.Person;
  personLink: any[];
  personName: string = '';
  settings = SettingsService;

  ngOnChanges() {
    // Name in the url doesn't use title because data for the autocomplete dropdown doesn't have the title,
    // so use name with no title here for the route as well.
    let nameNoTitle = '';

    // Check for nulls, otherwise a 'null' is displayed at the front end
    if (this.person.firstName) {
      nameNoTitle += this.person.firstName + ' ';
    }

    if (this.person.lastName) {
      nameNoTitle += this.person.lastName;
    }

    if (this.person.title) {
      this.personName = `${this.person.title} ${nameNoTitle}`;
    } else {
      this.personName = nameNoTitle;
    }

    const id = this.person.id;
    const routeType = RouterHelperService.routeType.personProfile;
    const route = RouterHelperService.getRoute(routeType, id, nameNoTitle, null);
    this.personLink = route.link;
  }
}
